import { render } from "./TotalExpenses.vue?vue&type=template&id=5781c576"
import script from "./TotalExpenses.vue?vue&type=script&lang=js"
export * from "./TotalExpenses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__